import { Layout } from '../layouts/Layout';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import DeviceTable from '../components/DeviceTable';
import { useDevices } from '../hooks/useDevices';

/**
 * Devices page component
 * Displays device management interface with table of all devices
 * Uses useDevices hook for data fetching
 */
export default function Devices() {
  const { devices, loading, error } = useDevices();

  return (
    <Layout>
      <Sidebar />
      <Header title="Device Management" />

      <main className="ml-0 md:ml-64 pt-20 p-6">
        <div className="bg-white rounded-lg shadow">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <div className="inline-flex items-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Loading devices...
              </div>
            </div>
          ) : error ? (
            <div className="flex items-center justify-center py-12 text-red-600">
              Error loading devices: {error}
            </div>
          ) : (
            <DeviceTable devices={devices} />
          )}
        </div>
      </main>
    </Layout>
  );
}
